module.exports = __webpack_public_path__ + "static/preview-summer-catchers-97d9ba5c6a25516a0de6f3f70c4a1fd9.png";